import React from "react";
import { useTranslation } from "react-i18next";

function UsingSkills() {
    const { t } = useTranslation();

    return (
        <div className="max-w-5xl mx-auto px-4 py-8">
            <div className="mb-8">
                <h1 className="text-3xl font-semibold mb-2">
                    {t("usingSkills.title")}
                </h1>
                <p className="text-gray-600 ">
                    {t("usingSkills.subtitle")}
                </p>

                <div className="mt-6">
                    <p className="text-gray-600 ">
                        {t("usingSkills.intro")}
                    </p>
                </div>
            </div>

            <div className="space-y-12">
                {/* What Are Skills Section */}
                <section>
                    <h2 className="text-2xl font-semibold mb-4">
                        {t("usingSkills.whatAreSkills.title")}
                    </h2>
                    <p className="mb-6">
                        {t("usingSkills.whatAreSkills.description")}
                    </p>

                    <div className="bg-blue-50  p-6 rounded-lg">
                        <h3 className="text-xl font-medium mb-4">
                            {t("usingSkills.whatAreSkills.benefits.title")}
                        </h3>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div className="flex items-start">
                                <div className="flex items-center justify-center w-8 h-8 bg-blue-100 dark:bg-blue-800 rounded-full mr-3 flex-shrink-0">
                                    <span className="text-blue-600 dark:text-blue-300">
                                        1
                                    </span>
                                </div>
                                <p>
                                    {t(
                                        "usingSkills.whatAreSkills.benefits.benefit1"
                                    )}
                                </p>
                            </div>
                            <div className="flex items-start">
                                <div className="flex items-center justify-center w-8 h-8 bg-blue-100 dark:bg-blue-800 rounded-full mr-3 flex-shrink-0">
                                    <span className="text-blue-600 dark:text-blue-300">
                                        2
                                    </span>
                                </div>
                                <p>
                                    {t(
                                        "usingSkills.whatAreSkills.benefits.benefit2"
                                    )}
                                </p>
                            </div>
                            <div className="flex items-start">
                                <div className="flex items-center justify-center w-8 h-8 bg-blue-100 dark:bg-blue-800 rounded-full mr-3 flex-shrink-0">
                                    <span className="text-blue-600 dark:text-blue-300">
                                        3
                                    </span>
                                </div>
                                <p>
                                    {t(
                                        "usingSkills.whatAreSkills.benefits.benefit3"
                                    )}
                                </p>
                            </div>
                            <div className="flex items-start">
                                <div className="flex items-center justify-center w-8 h-8 bg-blue-100 dark:bg-blue-800 rounded-full mr-3 flex-shrink-0">
                                    <span className="text-blue-600 dark:text-blue-300">
                                        4
                                    </span>
                                </div>
                                <p>
                                    {t(
                                        "usingSkills.whatAreSkills.benefits.benefit4"
                                    )}
                                </p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Accessing Skills Section */}
                <section>
                    <h2 className="text-2xl font-semibold mb-4">
                        {t("usingSkills.accessingSkills.title")}
                    </h2>
                    <p className="mb-6">
                        {t("usingSkills.accessingSkills.description")}
                    </p>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                        <div className="bg-white  rounded-lg border border-gray-200  overflow-hidden">
                            <div className="bg-purple-50  p-4 border-b border-gray-200 ">
                                <h3 className="text-xl font-medium">
                                    {t(
                                        "usingSkills.accessingSkills.method1.title"
                                    )}
                                </h3>
                            </div>
                            <div className="p-4">
                                <ol className="list-decimal pl-6 space-y-2">
                                    {t(
                                        "usingSkills.accessingSkills.method1.steps",
                                        { returnObjects: true }
                                    ).map((step, index) => (
                                        <li
                                            key={index}
                                            className="text-gray-700 "
                                        >
                                            {step}
                                        </li>
                                    ))}
                                </ol>
                            </div>
                            <div className="p-4 bg-gray-50  border-t border-gray-200 ">
                                <div className="flex items-center">
                                    <div className="w-10 h-10 bg-blue-100  flex items-center justify-center rounded-full">
                                        <span className="text-xl">@</span>
                                    </div>
                                    <div className="ml-3">
                                        <span className="text-sm font-medium">
                                            @ChatGPT, @ExcelProcessor...
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="bg-white  rounded-lg border border-gray-200  overflow-hidden">
                            <div className="bg-blue-50  p-4 border-b border-gray-200 ">
                                <h3 className="text-xl font-medium">
                                    {t(
                                        "usingSkills.accessingSkills.method2.title"
                                    )}
                                </h3>
                            </div>
                            <div className="p-4">
                                <ol className="list-decimal pl-6 space-y-2">
                                    {t(
                                        "usingSkills.accessingSkills.method2.steps",
                                        { returnObjects: true }
                                    ).map((step, index) => (
                                        <li
                                            key={index}
                                            className="text-gray-700 "
                                        >
                                            {step}
                                        </li>
                                    ))}
                                </ol>
                            </div>
                            <div className="p-4 bg-gray-50  border-t border-gray-200  flex justify-center">
                                <div className="px-3 py-1 bg-blue-600 text-white text-sm rounded">
                                    {
                                        t(
                                            "usingSkills.accessingSkills.method2.steps"
                                        )[3]
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Using Skills in Conversation */}
                <section>
                    <h2 className="text-2xl font-semibold mb-4">
                        {t("usingSkills.usingInConversation.title")}
                    </h2>
                    <p className="mb-4">
                        {t("usingSkills.usingInConversation.description")}
                    </p>
                    <div className="mb-6 p-4 bg-yellow-50 dark:bg-yellow-900/30 border-l-4 border-yellow-500 rounded-lg text-center">
                        <p className="font-medium">
                            {t("usingSkills.usingInConversation.pattern")}
                        </p>
                    </div>

                    <div className="space-y-6">
                        {/* Example 1 */}
                        <div className="bg-white  shadow-sm rounded-lg overflow-hidden border border-gray-200 ">
                            <div className="p-4 bg-blue-50  border-b border-gray-200 ">
                                <h3 className="font-medium">
                                    {t(
                                        "usingSkills.usingInConversation.example1.title"
                                    )}
                                </h3>
                            </div>
                            <div className="p-4 bg-gray-50  font-mono text-sm border-b border-gray-200 ">
                                {t(
                                    "usingSkills.usingInConversation.example1.prompt"
                                )}
                            </div>
                            <div className="p-4 text-sm text-gray-600 ">
                                <em>
                                    {t(
                                        "usingSkills.usingInConversation.example1.explanation"
                                    )}
                                </em>
                            </div>
                        </div>

                        {/* Example 2 */}
                        <div className="bg-white  shadow-sm rounded-lg overflow-hidden border border-gray-200 ">
                            <div className="p-4 bg-green-50  border-b border-gray-200 ">
                                <h3 className="font-medium">
                                    {t(
                                        "usingSkills.usingInConversation.example2.title"
                                    )}
                                </h3>
                            </div>
                            <div className="p-4 bg-gray-50  font-mono text-sm border-b border-gray-200 ">
                                {t(
                                    "usingSkills.usingInConversation.example2.prompt"
                                )}
                            </div>
                            <div className="p-4 text-sm text-gray-600 ">
                                <em>
                                    {t(
                                        "usingSkills.usingInConversation.example2.explanation"
                                    )}
                                </em>
                            </div>
                        </div>
                    </div>

                    <div className="mt-8">
                        <h3 className="text-xl font-medium mb-4">
                            {t(
                                "usingSkills.usingInConversation.parameters.title"
                            )}
                        </h3>
                        <p className="mb-4">
                            {t(
                                "usingSkills.usingInConversation.parameters.description"
                            )}
                        </p>
                        <div className="space-y-3 pl-6">
                            <div className="flex items-start">
                                <span className="text-blue-600 mr-2">•</span>
                                <p>
                                    {t(
                                        "usingSkills.usingInConversation.parameters.method1"
                                    )}
                                </p>
                            </div>
                            <div className="flex items-start">
                                <span className="text-blue-600 mr-2">•</span>
                                <p>
                                    {t(
                                        "usingSkills.usingInConversation.parameters.method2"
                                    )}
                                </p>
                            </div>
                            <div className="flex items-start">
                                <span className="text-blue-600 mr-2">•</span>
                                <p>
                                    {t(
                                        "usingSkills.usingInConversation.parameters.method3"
                                    )}
                                </p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Popular Skills Overview */}
                <section className="bg-gray-50  p-8 rounded-lg">
                    <h2 className="text-2xl font-semibold mb-4">
                        {t("usingSkills.popularSkills.title")}
                    </h2>
                    <p className="mb-6">
                        {t("usingSkills.popularSkills.intro")}
                    </p>

                    <div className="space-y-6">
                        {/* Skill 1 */}
                        <div className="bg-white  p-4 rounded-lg shadow-sm">
                            <div className="flex items-center mb-2">
                                <div className="w-10 h-10 rounded-full bg-blue-100 dark:bg-blue-800 flex items-center justify-center mr-3">
                                    <span className="text-blue-600 dark:text-blue-300 text-xl">
                                        🤖
                                    </span>
                                </div>
                                <h3 className="font-medium text-lg">
                                    {t("usingSkills.popularSkills.skill1.name")}
                                </h3>
                            </div>
                            <p className="mb-3 text-gray-600 ">
                                {t(
                                    "usingSkills.popularSkills.skill1.description"
                                )}
                            </p>
                            <div className="bg-gray-100  p-2 rounded font-mono text-sm">
                                {t(
                                    "usingSkills.popularSkills.skill1.usageExample"
                                )}
                            </div>
                        </div>

                        {/* Skill 2 */}
                        <div className="bg-white  p-4 rounded-lg shadow-sm">
                            <div className="flex items-center mb-2">
                                <div className="w-10 h-10 rounded-full bg-green-100 dark:bg-green-800 flex items-center justify-center mr-3">
                                    <span className="text-green-600 dark:text-green-300 text-xl">
                                        📊
                                    </span>
                                </div>
                                <h3 className="font-medium text-lg">
                                    {t("usingSkills.popularSkills.skill2.name")}
                                </h3>
                            </div>
                            <p className="mb-3 text-gray-600 ">
                                {t(
                                    "usingSkills.popularSkills.skill2.description"
                                )}
                            </p>
                            <div className="bg-gray-100  p-2 rounded font-mono text-sm">
                                {t(
                                    "usingSkills.popularSkills.skill2.usageExample"
                                )}
                            </div>
                        </div>

                        {/* Skill 3 */}
                        <div className="bg-white  p-4 rounded-lg shadow-sm">
                            <div className="flex items-center mb-2">
                                <div className="w-10 h-10 rounded-full bg-purple-100 dark:bg-purple-800 flex items-center justify-center mr-3">
                                    <span className="text-purple-600  text-xl">
                                        📝
                                    </span>
                                </div>
                                <h3 className="font-medium text-lg">
                                    {t("usingSkills.popularSkills.skill3.name")}
                                </h3>
                            </div>
                            <p className="mb-3 text-gray-600 ">
                                {t(
                                    "usingSkills.popularSkills.skill3.description"
                                )}
                            </p>
                            <div className="bg-gray-100  p-2 rounded font-mono text-sm">
                                {t(
                                    "usingSkills.popularSkills.skill3.usageExample"
                                )}
                            </div>
                        </div>

                        {/* Only show more skills on larger screens */}
                        <div className="md:grid md:grid-cols-2 gap-6 hidden">
                            {/* Skill 4 */}
                            <div className="bg-white  p-4 rounded-lg shadow-sm">
                                <div className="flex items-center mb-2">
                                    <div className="w-10 h-10 rounded-full bg-yellow-100 dark:bg-yellow-800 flex items-center justify-center mr-3">
                                        <span className="text-yellow-600 dark:text-yellow-300 text-xl">
                                            📧
                                        </span>
                                    </div>
                                    <h3 className="font-medium text-lg">
                                        {t(
                                            "usingSkills.popularSkills.skill4.name"
                                        )}
                                    </h3>
                                </div>
                                <p className="mb-3 text-gray-600 ">
                                    {t(
                                        "usingSkills.popularSkills.skill4.description"
                                    )}
                                </p>
                                <div className="bg-gray-100  p-2 rounded font-mono text-sm">
                                    {t(
                                        "usingSkills.popularSkills.skill4.usageExample"
                                    )}
                                </div>
                            </div>

                            {/* Skill 5 */}
                            <div className="bg-white  p-4 rounded-lg shadow-sm">
                                <div className="flex items-center mb-2">
                                    <div className="w-10 h-10 rounded-full bg-red-100 dark:bg-red-800 flex items-center justify-center mr-3">
                                        <span className="text-red-600 dark:text-red-300 text-xl">
                                            📈
                                        </span>
                                    </div>
                                    <h3 className="font-medium text-lg">
                                        {t(
                                            "usingSkills.popularSkills.skill5.name"
                                        )}
                                    </h3>
                                </div>
                                <p className="mb-3 text-gray-600 ">
                                    {t(
                                        "usingSkills.popularSkills.skill5.description"
                                    )}
                                </p>
                                <div className="bg-gray-100  p-2 rounded font-mono text-sm">
                                    {t(
                                        "usingSkills.popularSkills.skill5.usageExample"
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Combining Skills Section */}
                <section>
                    <h2 className="text-2xl font-semibold mb-4">
                        {t("usingSkills.combiningSkills.title")}
                    </h2>
                    <p className="mb-6">
                        {t("usingSkills.combiningSkills.description")}
                    </p>

                    <div className="bg-white  shadow-sm rounded-lg overflow-hidden border border-gray-200  mb-6">
                        <div className="p-4 bg-green-50  border-b border-gray-200 ">
                            <h3 className="font-medium">
                                {t("usingSkills.combiningSkills.example.title")}
                            </h3>
                        </div>
                        <div className="p-4">
                            <ol className="list-decimal pl-6 space-y-4">
                                {t(
                                    "usingSkills.combiningSkills.example.steps",
                                    { returnObjects: true }
                                ).map((step, index) => (
                                    <li
                                        key={index}
                                        className="font-mono text-sm"
                                    >
                                        {step}
                                    </li>
                                ))}
                            </ol>
                        </div>
                        <div className="p-4 bg-gray-50  border-t border-gray-200  text-sm text-gray-600 ">
                            <em>
                                {t(
                                    "usingSkills.combiningSkills.example.explanation"
                                )}
                            </em>
                        </div>
                    </div>

                    <div className="bg-yellow-50 dark:bg-yellow-900/30 p-4 rounded-lg border-l-4 border-yellow-500">
                        <p className="font-medium">
                            {t("usingSkills.combiningSkills.tips")}
                        </p>
                    </div>
                </section>

                {/* Best Practices Section */}
                <section>
                    <h2 className="text-2xl font-semibold mb-6">
                        {t("usingSkills.bestPractices.title")}
                    </h2>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div className="bg-white  p-5 rounded-lg shadow-sm border border-gray-200 ">
                            <div className="flex items-start">
                                <div className="w-10 h-10 bg-blue-100 dark:bg-blue-800 rounded-full flex items-center justify-center mr-3 flex-shrink-0">
                                    <span className="text-blue-600 dark:text-blue-300">
                                        1
                                    </span>
                                </div>
                                <div>
                                    <h3 className="font-medium mb-2">
                                        {t(
                                            "usingSkills.bestPractices.practice1.title"
                                        )}
                                    </h3>
                                    <p className="text-gray-600  text-sm">
                                        {t(
                                            "usingSkills.bestPractices.practice1.description"
                                        )}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="bg-white  p-5 rounded-lg shadow-sm border border-gray-200 ">
                            <div className="flex items-start">
                                <div className="w-10 h-10 bg-blue-100 dark:bg-blue-800 rounded-full flex items-center justify-center mr-3 flex-shrink-0">
                                    <span className="text-blue-600 dark:text-blue-300">
                                        2
                                    </span>
                                </div>
                                <div>
                                    <h3 className="font-medium mb-2">
                                        {t(
                                            "usingSkills.bestPractices.practice2.title"
                                        )}
                                    </h3>
                                    <p className="text-gray-600  text-sm">
                                        {t(
                                            "usingSkills.bestPractices.practice2.description"
                                        )}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="bg-white  p-5 rounded-lg shadow-sm border border-gray-200 ">
                            <div className="flex items-start">
                                <div className="w-10 h-10 bg-blue-100 dark:bg-blue-800 rounded-full flex items-center justify-center mr-3 flex-shrink-0">
                                    <span className="text-blue-600 dark:text-blue-300">
                                        3
                                    </span>
                                </div>
                                <div>
                                    <h3 className="font-medium mb-2">
                                        {t(
                                            "usingSkills.bestPractices.practice3.title"
                                        )}
                                    </h3>
                                    <p className="text-gray-600  text-sm">
                                        {t(
                                            "usingSkills.bestPractices.practice3.description"
                                        )}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="bg-white  p-5 rounded-lg shadow-sm border border-gray-200 ">
                            <div className="flex items-start">
                                <div className="w-10 h-10 bg-blue-100 dark:bg-blue-800 rounded-full flex items-center justify-center mr-3 flex-shrink-0">
                                    <span className="text-blue-600 dark:text-blue-300">
                                        4
                                    </span>
                                </div>
                                <div>
                                    <h3 className="font-medium mb-2">
                                        {t(
                                            "usingSkills.bestPractices.practice4.title"
                                        )}
                                    </h3>
                                    <p className="text-gray-600  text-sm">
                                        {t(
                                            "usingSkills.bestPractices.practice4.description"
                                        )}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="bg-white  p-5 rounded-lg shadow-sm border border-gray-200  md:col-span-2">
                            <div className="flex items-start">
                                <div className="w-10 h-10 bg-blue-100 dark:bg-blue-800 rounded-full flex items-center justify-center mr-3 flex-shrink-0">
                                    <span className="text-blue-600 dark:text-blue-300">
                                        5
                                    </span>
                                </div>
                                <div>
                                    <h3 className="font-medium mb-2">
                                        {t(
                                            "usingSkills.bestPractices.practice5.title"
                                        )}
                                    </h3>
                                    <p className="text-gray-600  text-sm">
                                        {t(
                                            "usingSkills.bestPractices.practice5.description"
                                        )}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Troubleshooting Section */}
                <section className="bg-gray-50  p-6 rounded-lg">
                    <h2 className="text-2xl font-semibold mb-6">
                        {t("usingSkills.troubleshooting.title")}
                    </h2>

                    <div className="space-y-6">
                        <div className="bg-white  p-4 rounded-lg shadow-sm">
                            <h3 className="font-medium mb-2">
                                {t(
                                    "usingSkills.troubleshooting.problem1.title"
                                )}
                            </h3>
                            <p className="text-gray-600 ">
                                <span className="font-medium text-blue-600 dark:text-blue-300">
                                    Solution:
                                </span>{" "}
                                {t(
                                    "usingSkills.troubleshooting.problem1.solution"
                                )}
                            </p>
                        </div>

                        <div className="bg-white  p-4 rounded-lg shadow-sm">
                            <h3 className="font-medium mb-2">
                                {t(
                                    "usingSkills.troubleshooting.problem2.title"
                                )}
                            </h3>
                            <p className="text-gray-600 ">
                                <span className="font-medium text-blue-600 dark:text-blue-300">
                                    Solution:
                                </span>{" "}
                                {t(
                                    "usingSkills.troubleshooting.problem2.solution"
                                )}
                            </p>
                        </div>

                        <div className="bg-white  p-4 rounded-lg shadow-sm">
                            <h3 className="font-medium mb-2">
                                {t(
                                    "usingSkills.troubleshooting.problem3.title"
                                )}
                            </h3>
                            <p className="text-gray-600 ">
                                <span className="font-medium text-blue-600 dark:text-blue-300">
                                    Solution:
                                </span>{" "}
                                {t(
                                    "usingSkills.troubleshooting.problem3.solution"
                                )}
                            </p>
                        </div>

                        <div className="bg-white  p-4 rounded-lg shadow-sm">
                            <h3 className="font-medium mb-2">
                                {t(
                                    "usingSkills.troubleshooting.problem4.title"
                                )}
                            </h3>
                            <p className="text-gray-600 ">
                                <span className="font-medium text-blue-600 dark:text-blue-300">
                                    Solution:
                                </span>{" "}
                                {t(
                                    "usingSkills.troubleshooting.problem4.solution"
                                )}
                            </p>
                        </div>
                    </div>

                    <div className="mt-6 p-4 bg-blue-50 /30 border border-blue-200 dark:border-blue-700 rounded-lg">
                        <p className="text-center font-medium">
                            {t("usingSkills.troubleshooting.getHelp")}
                        </p>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default UsingSkills;
